import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Shell from "@/components/layout/Shell";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ExpertisePage from "@/pages/ExpertisePage";
import TechniquesPage from "@/pages/TechniquesPage";
import BrachytherapyPage from "@/pages/BrachytherapyPage";
import ApproachPage from "@/pages/ApproachPage";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/">
        <Routes>
          <Route element={<Shell />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/expertise" element={<ExpertisePage />} />
            <Route path="/techniques" element={<TechniquesPage />} />
            <Route path="/brachytherapy" element={<BrachytherapyPage />} />
            <Route path="/approach" element={<ApproachPage />} />
            <Route path="/faqs" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}
